import { axiosInstance, axiosInstanceBet, getApiLanguage } from "./axiosInstances";
import { PaymentEndpoints } from "../constant/Environment";
import { getUtmTrackingId } from "./utmStorage";
//axiosFormInstance
let header_token;
export const setHeader = async (token) => {
  header_token = token;
};

const exports = {
  setHeader,
};

export default exports;

const isPaymentApiUrl = (url) => {
  if (!url || typeof url !== "string") {
    return false;
  }
  return url.startsWith(PaymentEndpoints.apiBaseUrl);
};

const paymentSafeHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const addData = async (endpoint, requestBody) => {
  try {
    const result = isPaymentApiUrl(endpoint)
      ? await axiosInstance.post(endpoint, requestBody, {
          headers: paymentSafeHeaders,
          transformRequest: [(data, headers) => {
            delete headers.token;
            delete headers.session_id;
            delete headers.SessonId;
            delete headers.Sessonid;
            delete headers.SessionId;
            return JSON.stringify(data);
          }],
        })
      : await axiosInstance.post(endpoint, requestBody);
    return result;
  } catch (error) {
    return error;
  }
};
export const addBetData = async (endpoint, requestBody) => {
  try {
    const result = isPaymentApiUrl(endpoint)
      ? await axiosInstanceBet.post(endpoint, requestBody, {
          headers: paymentSafeHeaders,
          transformRequest: [(data, headers) => {
            delete headers.token;
            delete headers.session_id;
            delete headers.SessonId;
            delete headers.Sessonid;
            delete headers.SessionId;
            return JSON.stringify(data);
          }],
        })
      : await axiosInstanceBet.post(endpoint, requestBody);
    return result;
  } catch (error) {
    return error;
  }
};
export const getData = async (url) => {
  try {
    let result = await axiosInstanceBet.get(url);
    return result.data;
  } catch (error) {
    return error.response;
  }
};
export const updateBetUser = async (url, data) => {
  try {
    let result = await axiosInstanceBet.put(`${url}`, data);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getAllBetData = async (url) => {
  try {
    let result = await axiosInstanceBet.get(url);
    return result.data;
  } catch (error) {
    return error.response;
  }
};

export const updateData = async (endpoint, requestBody) => {
  try {
    const result = await axiosInstance.patch(endpoint, requestBody);
    return result;
  } catch (error) {
    return error;
  }
};

export const deleteData = async (endpoint) => {
  try {
    const result = await axiosInstance.delete(endpoint);
    return result;
  } catch (error) {
    return error;
  }
};

export const getAllData = async (url) => {
  try {
    let result = isPaymentApiUrl(url)
      ? await axiosInstance.get(url, {
          headers: paymentSafeHeaders,
          transformRequest: [(data, headers) => {
            delete headers.token;
            delete headers.session_id;
            delete headers.SessonId;
            delete headers.Sessonid;
            delete headers.SessionId;
            return data;
          }],
        })
      : await axiosInstance.get(url);
    return result.data;
  } catch (error) {
    return error.response;
  }
};

export const updateUser = async (url, data) => {
  try {
    let result = await axiosInstance.put(`${url}`, data);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export async function fetchAllData(url) {
  // let tokenStr = await getHeaders();
  var myHeaders = new Headers();
  // myHeaders.append("Authorization", `Bearer ${tokenStr}`);
  // Raw fetch bypasses the axios interceptors, so set the language and the utm
  // tracking id here too.
  myHeaders.append("Accept-Language", getApiLanguage());
  const utmTrackingId = getUtmTrackingId();
  if (utmTrackingId) {
    myHeaders.append("utmTrackingId", utmTrackingId);
  }

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  // return fetch(BASE_URL+url, requestOptions);
  return fetch(url, requestOptions);
}
